import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../../../../components/SearchForm/components/TravelTypeField/components/Container.js';
import { ViewSwitch } from '../../../../components/SearchForm/components/ViewSwitch/index.js';
export const Component = forwardRef(({
  value,
  onChange,
  onFocus,
  onBlur,
  options,
  mode = 'selectLight',
  layout,
  ...restProps
}, ref) => _jsx(Container, {
  inverted: layout === 'sidebar',
  ...restProps,
  children: _jsx(ViewSwitch, {
    ref: ref,
    value: value,
    mode: mode,
    onFocus: onFocus,
    onBlur: onBlur,
    options: options,
    onChange: value => onChange(value)
  })
}));
export const TravelTypeField = /*#__PURE__*/_styled(Component, process.env.NODE_ENV === "production" ? {
  target: "epdgguk0"
} : {
  target: "epdgguk0",
  label: "TravelTypeField"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRyYXZlbFR5cGVGaWVsZC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNaUQiLCJmaWxlIjoiVHJhdmVsVHlwZUZpZWxkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3ggfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi8uLi8uLi9jb21wb25lbnRzL1NlYXJjaEZvcm0vY29tcG9uZW50cy9UcmF2ZWxUeXBlRmllbGQvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgVmlld1N3aXRjaCB9IGZyb20gJy4uLy4uLy4uLy4uL2NvbXBvbmVudHMvU2VhcmNoRm9ybS9jb21wb25lbnRzL1ZpZXdTd2l0Y2gvaW5kZXguanMnO1xuZXhwb3J0IGNvbnN0IENvbXBvbmVudCA9IGZvcndhcmRSZWYoKHsgdmFsdWUsIG9uQ2hhbmdlLCBvbkZvY3VzLCBvbkJsdXIsIG9wdGlvbnMsIG1vZGUgPSAnc2VsZWN0TGlnaHQnLCBsYXlvdXQsIC4uLnJlc3RQcm9wcyB9LCByZWYpID0+IChfanN4KENvbnRhaW5lciwgeyBpbnZlcnRlZDogbGF5b3V0ID09PSAnc2lkZWJhcicsIC4uLnJlc3RQcm9wcywgY2hpbGRyZW46IF9qc3goVmlld1N3aXRjaCwgeyByZWY6IHJlZiwgdmFsdWU6IHZhbHVlLCBtb2RlOiBtb2RlLCBvbkZvY3VzOiBvbkZvY3VzLCBvbkJsdXI6IG9uQmx1ciwgb3B0aW9uczogb3B0aW9ucywgb25DaGFuZ2U6ICh2YWx1ZSkgPT4gb25DaGFuZ2UodmFsdWUpIH0pIH0pKSk7XG5leHBvcnQgY29uc3QgVHJhdmVsVHlwZUZpZWxkID0gc3R5bGVkKENvbXBvbmVudCkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1UcmF2ZWxUeXBlRmllbGQuanMubWFwIl19 */");